import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import { NitroIcon } from "nitro-components";

const DriverAvatarContainer = styled.div`
  position: relative;
  float: left;
  margin-right: ${props => props.right}px;
  border-radius: 100%;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background: ${props => props.theme.color[props.variant]};
  opacity:${props => props.opacity};
  margin-bottom:${props => (props.bottom)}px;
`;
const DriverIcon = styled.i`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const DriverAvatar = props => {
	const {
		variant,
		size,
		profileIconVariant,
		profileIconSize,
		opacity,
		bottom,
    right
	} = props;

	return (
		<DriverAvatarContainer
			size={size}
			variant={variant}
			opacity={opacity}
			bottom={bottom}
			right={right}
		>
			<DriverIcon>
				<NitroIcon
					name="profile"
					size={profileIconSize}
					variant={profileIconVariant}
				/>
			</DriverIcon>
		</DriverAvatarContainer>
	);
};

DriverAvatar.propTypes = {
	profileIconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	profileIconVariant: PropTypes.string,
	variant: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	opacity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	right: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

DriverAvatar.defaultProps = {
	size: 60,
	variant: "border",
	profileIconVariant: "white",
	opacity: 1,
	bottom: 0,
  right: 20
};

export default DriverAvatar;



// WEBPACK FOOTER //
// ./src/components/driver/DriverAvatar.js